import { Label, Textarea } from '@1trading/react';
import { Controller, type UseFormReturn, useWatch } from 'react-hook-form';
import { NARRATIVE_MAX_LENGTH } from '@/services/api/fiu-utr';
import type { FiuUtrFormValues } from './case-form';
import { IpChipsInput } from './ip-chips-input';

const NARRATIVE_ROWS = 10;

interface CaseDetailsSectionProps {
  form: UseFormReturn<FiuUtrFormValues>;
}

export const CaseDetailsSection = ({ form }: CaseDetailsSectionProps) => {
  const narrativeError = form.formState.errors.narrative?.message;
  const narrativeLength = useWatch({ control: form.control, name: 'narrative' }).length;
  const isNarrativeOverLimit = narrativeLength > NARRATIVE_MAX_LENGTH;
  return (
    <section className="flex flex-col gap-4">
      <h2 className="text-lg font-semibold">2. Case details</h2>
      <div className="flex max-w-[900px] flex-col gap-1.5">
        <Label htmlFor="fiu-narrative">Case narrative (becomes the report action text)</Label>
        <Textarea aria-describedby="fiu-narrative-count" id="fiu-narrative" rows={NARRATIVE_ROWS} {...form.register('narrative')} />
        <div className="flex items-start justify-between gap-4 text-sm">
          {narrativeError ? <p className="text-red-500">{narrativeError}</p> : <span />}
          <p className={isNarrativeOverLimit ? 'shrink-0 text-red-500' : 'shrink-0 text-muted-foreground'} id="fiu-narrative-count">
            {narrativeLength.toLocaleString()} / {NARRATIVE_MAX_LENGTH.toLocaleString()} characters
          </p>
        </div>
      </div>
      <div className="flex max-w-[900px] flex-col gap-1.5">
        <Label htmlFor="fiu-ips">Additional IP addresses (optional, press enter after each)</Label>
        <p className="text-sm text-muted-foreground">Each transaction's own IP is added automatically: the IP that requested it, or the client's login IP for that session.</p>
        <Controller control={form.control} name="ips" render={({ field }) => <IpChipsInput id="fiu-ips" onChange={field.onChange} value={field.value} />} />
      </div>
    </section>
  );
};
CaseDetailsSection.displayName = 'CaseDetailsSection';
